import { Accelerator } from '../../libraries/common';
import Vue from '../../vue';

Vue.directive('element-scroll', {
  inserted: el => {
    let lastScrollTop = 0;
    const scrollTo = top => el.scrollTo({ top });
    let accelerator = new Accelerator(scrollTo, 0.1);

    const setFrom = (event) => {
      if (!accelerator.isRunning) {
        Vue.nextTick(() => {
          lastScrollTop = event.currentTarget.scrollTop;
          accelerator.setFrom(event.currentTarget.scrollTop);
        });
      }
    };
    const accelerate = (event) => {
      event.preventDefault();
      lastScrollTop = Math.max(Math.min(lastScrollTop + event.deltaY, el.scrollHeight - el.offsetHeight), 0);
      accelerator.setTo(lastScrollTop);
    };

    el.addEventListener('scroll', setFrom);
    el.addEventListener('mousewheel', accelerate);
  },
});